import React from 'react'
import atencionAlCliente from "../../img/cardAtencionAlCliente.jpg";
import "../../css/card.css";
import { Link } from 'react-router-dom';
const Card = () => {
   return (
      <>
         <div className="section animated fadeIn">
            <div className="row">
               <div className="col s12 m6 l3 x3">
                  <div className="card card-img-atencion-cliente">
                     <div className="card-content opacity white-text justify">
                        <div className="center">
                           <span className="white-text">
                              <strong>ATENCIÓN AL CLIENTE</strong><br/>
                              <h5><strong>0800-199-0023</strong></h5>
                              &nbsp;
                           </span>
                        </div>
                     </div>
                  </div>
               </div>
               <div className="col s12 m6 l3 x3">
                  <div className="card card-img-centro-atencion">
                     <div className="card-content opacity white-text justify">
                        <div className="center">
                           <span className="white-text">
                              <strong>CENTROS DE ATENCIÓN</strong><br/>
                              <h5><strong>JUJUY y SALTA</strong></h5>
                              &nbsp;
                           </span>
                        </div>
                     </div>
                  </div>
               </div>
               <div className="col s12 m6 l3 x3">
                  <div className="card card-img-denuncia">
                     <div className="card-content opacity white-text justify">
                        <div className="center">
                           <span className="white-text">
                              <strong>DENUNCIA DE ACCIDENTES DE TRABAJO</strong><br/>
                              <h5><strong>0800-199-0022</strong></h5>
                           </span>
                        </div>
                     </div>
                  </div>
               </div>
               <div className="col s12 m6 l3 x3">
                  <div className="card card-img-automotor">
                     <div className="card-content opacity white-text justify">
                        <div className="center">
                           <span className="white-text">
                              <strong>DENUNCIA DE ACCIDENTES DE AUTOS</strong><br/>
                              <strong><p style={{"font-size": "18px"}}>(388) 517-4304 / (388) 685-9269</p></strong>
                           </span>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </>
   )
}

export default Card